import { Card, Image, Text, XStack, YStack } from '@frontend/web-react';
import type { ClassName } from '@frontend/web-utils';
import { concatClasses } from '@frontend/web-utils';
import { useNavigate } from '@tanstack/react-router';

export type TaskChatOptionSheetCardProps = {
  cardClassName?: ClassName;
  className?: ClassName;
  imageUrl?: string;
  optionSheetId: string;
  title: string;
};
export const TaskChatOptionSheetCard = ({
  cardClassName,
  className,
  imageUrl,
  optionSheetId,
  title,
}: TaskChatOptionSheetCardProps) => {
  const navigate = useNavigate();
  const onClickCard = () => navigate({ params: { optionSheetId }, to: '/app/option-sheet/$optionSheetId' });
  return (
    <XStack className={className}>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <Card
        className={concatClasses('rounded-lg bg-surfaceSecondary w-[300px] overflow-hidden', cardClassName)}
        onClick={onClickCard}
        withBorder
      >
        <YStack gapY="md">
          {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
          <Card.Section className="bg-surfacePrimary flex h-[129px] w-[294] flex-col items-center justify-center">
            {imageUrl ? (
              <Image className="size-full content-center object-cover" source={imageUrl} />
            ) : (
              <XStack className="p-sm">
                {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
                <Text className="rotate-[-10.582deg] self-center italic" type="h2">
                  {title.toLocaleUpperCase()}
                </Text>
              </XStack>
            )}
          </Card.Section>
          <XStack>
            <Text type="h5">{title}</Text>
          </XStack>
        </YStack>
      </Card>
    </XStack>
  );
};
